var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.027,
    height: 40,
    viewBox: "0 0 42.027 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pet",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91205",
    "data-name": "Path 91205",
    d: "M23.441,34.493H14.016A10.226,10.226,0,0,1,3.68,23.28a15.226,15.226,0,0,1,4.956-9.911A15.2,15.2,0,0,1,18.916,9.25,15.867,15.867,0,0,1,34,22.031a10.624,10.624,0,0,1-2.248,8.782,10.1,10.1,0,0,1-3.593,2.7A11.41,11.41,0,0,1,23.441,34.493ZM18.916,10.881A13.919,13.919,0,0,0,5.305,23.415a8.6,8.6,0,0,0,8.711,9.447h9.425A8.77,8.77,0,0,0,32.4,22.3,14.178,14.178,0,0,0,18.916,10.881Z",
    transform: "translate(0.374 4.757)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91206",
    "data-name": "Path 91206",
    d: "M12.955,13.219a5.734,5.734,0,1,1,5.734-5.734A5.741,5.741,0,0,1,12.955,13.219Zm0-9.838a4.1,4.1,0,1,0,4.1,4.1A4.108,4.108,0,0,0,12.955,3.381Z",
    transform: "translate(3.836 -2.5)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91207",
    "data-name": "Path 91207",
    d: "M19.3,13.451A4.751,4.751,0,1,1,24.051,8.7,4.756,4.756,0,0,1,19.3,13.451Zm0-7.871a3.12,3.12,0,1,0,3.12,3.12A3.123,3.123,0,0,0,19.3,5.581Z",
    transform: "translate(10.929 -0.371)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91208",
    "data-name": "Path 91208",
    d: "M22.517,16.484a3.767,3.767,0,1,1,3.767-3.767A3.771,3.771,0,0,1,22.517,16.484Zm0-5.9a2.136,2.136,0,1,0,2.136,2.136A2.139,2.139,0,0,0,22.517,10.581Z",
    transform: "translate(14.993 4.467)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91209",
    "data-name": "Path 91209",
    d: "M5.971,15.451A4.751,4.751,0,1,1,10.721,10.7,4.756,4.756,0,0,1,5.971,15.451Zm0-7.871a3.12,3.12,0,1,0,3.12,3.12A3.123,3.123,0,0,0,5.971,7.581Z",
    transform: "translate(-1.97 1.564)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/Pet.ba5171e831393244165d80f4aad98dd9.svg";
export { ForwardRef as ReactComponent };